package com.catbit.opinionpoll.core.sailor.providers

import androidx.compose.runtime.compositionLocalOf
import org.jetbrains.compose.web.css.CSSNumeric

val LocalZIndexProvider = compositionLocalOf<Int> {
    error("ZIndex was not provided")
}